import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8eacaf48&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=8eacaf48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eacaf48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eacaf48')) {
      api.createRecord('8eacaf48', component.options)
    } else {
      api.reload('8eacaf48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8eacaf48&scoped=true", function () {
      api.rerender('8eacaf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/index.vue"
export default component.exports